module.exports = __webpack_public_path__ + "static/media/project-3.582e2b7d.jpg";